function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React, { useContext, useEffect, useMemo } from "react";
import { injectTestId } from "@cvent/nucleus-test-automation";
import baseStyles from "./Textbox.style";
import { CarinaContext } from "../../../CarinaProvider/index";
import { isCarinaGlyph, remapIconSize } from "../../../Icon/types";
var Textbox = function(_param) {
    var accessibilityLabel = _param.accessibilityLabel, describedBy = _param.describedBy, disabled = _param.disabled, iconLeft = _param.iconLeft, iconRight = _param.iconRight, hasError = _param.hasError, required = _param.required, isRtl = _param.isRtl, name = _param.name, value = _param.value, placeholder = _param.placeholder, forwardedRef = _param.forwardedRef, styleProp = _param.style, testID = _param.testID, focused = _param.focused, onChange = _param.onChange, onChangeText = _param.onChangeText, _size = _param.size, size = _size === void 0 ? 'm' : _size, rest = _objectWithoutProperties(_param, [
        "accessibilityLabel",
        "describedBy",
        "disabled",
        "iconLeft",
        "iconRight",
        "hasError",
        "required",
        "isRtl",
        "name",
        "value",
        "placeholder",
        "forwardedRef",
        "style",
        "testID",
        "focused",
        "onChange",
        "onChangeText",
        "size"
    ]);
    var styles = useStyles({
        styleProp: styleProp,
        defaultStyles: baseStyles,
        hasError: hasError,
        isRtl: isRtl,
        disabled: disabled,
        iconLeft: iconLeft,
        iconRight: iconRight,
        size: size
    });
    var ref;
    var ref1 = (ref = useContext(CarinaContext)) !== null && ref !== void 0 ? ref : {
        flags: {
            placeholderRemoval: false
        }
    }, placeholderRemoval = ref1.flags.placeholderRemoval;
    useEffect(function() {
        if ((forwardedRef === null || forwardedRef === void 0 ? void 0 : forwardedRef.current) && focused) {
            forwardedRef.current.focus();
        }
    }, []);
    var handleOnChange = function(event) {
        if (onChange) {
            onChange(event);
        }
        if (onChangeText) {
            onChangeText(event.target.value);
        }
    };
    return _jsxs("div", _objectSpread({
        css: styles.container,
        dir: isRtl ? 'rtl' : 'ltr'
    }, injectTestId(testID), {
        children: [
            iconLeft && _jsx(Icon, {
                icon: iconLeft,
                direction: "left",
                iconContainerStyle: styles.iconContainer,
                iconStyle: styles.icon
            }),
            _jsx("input", _objectSpread({}, rest, {
                onChange: handleOnChange
            }, forwardedRef ? {
                ref: forwardedRef
            } : {}, {
                css: styles.input,
                "aria-label": accessibilityLabel,
                "aria-invalid": hasError,
                "aria-describedby": describedBy,
                disabled: disabled,
                placeholder: placeholderRemoval ? undefined : placeholder,
                value: value
            }, name ? {
                name: name
            } : {}, required ? {
                required: true
            } : {})),
            iconRight && _jsx(Icon, {
                icon: iconRight,
                direction: "right",
                iconContainerStyle: styles.iconContainer,
                iconStyle: styles.icon
            })
        ]
    }));
};
var useStyles = function(param) {
    var styleProp = param.styleProp, defaultStyles = param.defaultStyles, hasError = param.hasError, isRtl = param.isRtl, disabled = param.disabled, iconLeft = param.iconLeft, iconRight = param.iconRight, _size = param.size, size = _size === void 0 ? 'm' : _size;
    return useMemo(function() {
        var ref, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
        var mergedStyles = typeof styleProp === 'function' ? styleProp(defaultStyles) : _objectSpread({}, defaultStyles, styleProp, {
            input: _objectSpread({}, defaultStyles === null || defaultStyles === void 0 ? void 0 : defaultStyles.input, styleProp === null || styleProp === void 0 ? void 0 : styleProp.input, {
                base: _objectSpread({}, defaultStyles === null || defaultStyles === void 0 ? void 0 : (ref = defaultStyles.input) === null || ref === void 0 ? void 0 : ref.base, styleProp === null || styleProp === void 0 ? void 0 : (ref2 = styleProp.input) === null || ref2 === void 0 ? void 0 : ref2.base)
            })
        });
        return {
            container: mergedStyles === null || mergedStyles === void 0 ? void 0 : mergedStyles.container,
            input: _objectSpread({}, mergedStyles === null || mergedStyles === void 0 ? void 0 : (ref3 = mergedStyles.input) === null || ref3 === void 0 ? void 0 : ref3.base, mergedStyles === null || mergedStyles === void 0 ? void 0 : (ref4 = mergedStyles.input) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.size) === null || ref5 === void 0 ? void 0 : ref5[size], hasError && (mergedStyles === null || mergedStyles === void 0 ? void 0 : (ref6 = mergedStyles.input) === null || ref6 === void 0 ? void 0 : ref6.hasError), isRtl && (mergedStyles === null || mergedStyles === void 0 ? void 0 : (ref7 = mergedStyles.input) === null || ref7 === void 0 ? void 0 : ref7.isRtl), iconLeft && (mergedStyles === null || mergedStyles === void 0 ? void 0 : (ref8 = mergedStyles.input) === null || ref8 === void 0 ? void 0 : ref8.iconLeft), iconRight && (mergedStyles === null || mergedStyles === void 0 ? void 0 : (ref9 = mergedStyles.input) === null || ref9 === void 0 ? void 0 : ref9.iconRight), disabled && (mergedStyles === null || mergedStyles === void 0 ? void 0 : (ref10 = mergedStyles.input) === null || ref10 === void 0 ? void 0 : ref10.disabled)),
            iconContainer: mergedStyles === null || mergedStyles === void 0 ? void 0 : mergedStyles.iconContainer,
            icon: mergedStyles === null || mergedStyles === void 0 ? void 0 : mergedStyles.icon
        };
    }, [
        styleProp,
        defaultStyles,
        hasError,
        isRtl,
        iconLeft,
        iconRight,
        disabled,
        size
    ]);
};
var Icon = function(param) {
    var IconComponent = param.icon, direction = param.direction, iconContainerStyle = param.iconContainerStyle, iconStyle = param.iconStyle;
    return _jsx("span", {
        css: [
            iconContainerStyle && iconContainerStyle.base,
            direction === 'left' ? iconContainerStyle === null || iconContainerStyle === void 0 ? void 0 : iconContainerStyle.iconLeft : {},
            direction === 'right' ? iconContainerStyle === null || iconContainerStyle === void 0 ? void 0 : iconContainerStyle.iconRight : {}
        ],
        children: typeof IconComponent === 'function' ? isCarinaGlyph(IconComponent) ? _jsx(IconComponent, _objectSpread({}, iconStyle, {
            size: remapIconSize(iconStyle === null || iconStyle === void 0 ? void 0 : iconStyle.size),
            fill: iconStyle === null || iconStyle === void 0 ? void 0 : iconStyle.color
        })) : _jsx(IconComponent, _objectSpread({}, iconStyle)) : IconComponent
    });
};
export default Textbox;
